import React from 'react'

import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '60px',
    background: 'radial-gradient(120.84% 120.84% at 50% 50%, #0084B6 0%, #000937 100%)',
  },
  teaserContainer: {
    paddingTop: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingLeft: theme.spacing(8),
  },
  contentContainer: {
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  teaserImage: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '25px',
    maxWidth: '330px',
  },
  header: {
    fontWeight: 500,
  },
  message: {
    marginTop: theme.spacing(2),
    maxWidth: '700px',
  },
  supportMessage: {
    maxWidth: '450px',
  },
  button: {
    width: 200,
    color: theme.palette.primary.main,
    backgroundColor: 'white',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  supportLink: {
    color: '#fff',
    textDecoration: 'underline',
  },
}))

const supportLink = 'https://www.scoir.com/support'

const TeaserCard = ({
  header,
  message,
  requestAccessHref,
  requestAccessText,
  imageSrc,
  imageAltText,
  showSupportMessage,
}) => {
  const styles = useStyles()
  const theme = useTheme()

  return (
    <Box className={styles.root}>
      <Box className={styles.teaserContainer}>
        <Box className={styles.contentContainer}>
          <Box>
            <img
              className={styles.teaserImage}
              src={imageSrc}
              alt={imageAltText}
            />
          </Box>
          <Typography
            variant="h2"
            className={styles.header}
          >
            {header}
          </Typography>
          <Typography
            variant="body2"
            className={styles.message}
          >
            {message}
          </Typography>
          <Button
            href={requestAccessHref}
            target="_blank"
            rel="noreferrer"
            variant="contained"
            className={styles.button}
          >
            {requestAccessText}&nbsp;&nbsp;
            <FontAwesomeIcon
              icon={faArrowRight}
              color={theme.palette.primary.main}
              className={styles.icon}
            />
          </Button>
          {showSupportMessage && (
            <Typography
              variant="body2"
              data-testid="support-message"
              className={styles.supportMessage}
            >
              Already signed up? Contact&nbsp;
              <a
                href={supportLink}
                target="_blank"
                rel="noreferrer"
                className={styles.supportLink}
              >
                Scoir Support
              </a>
              &nbsp;to ensure your account is properly set up to receive applications.
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}

TeaserCard.propTypes = {
  header: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  requestAccessHref: PropTypes.string.isRequired,
  requestAccessText: PropTypes.string,
  imageSrc: PropTypes.any.isRequired,
  imageAltText: PropTypes.string.isRequired,
  showSupportMessage: PropTypes.bool,
}

TeaserCard.defaultProps = {
  requestAccessText: 'Request Access Now',
  showSupportMessage: false,
}

export default TeaserCard
